import React from 'react';
import { Typography } from 'lib/cortiUI';
export const FieldTitle = ({ title, isRequired }) => {
    return (React.createElement(Typography, { variant: "subtitle2" },
        title,
        React.createElement(Typography, { color: "error", display: "inline" }, isRequired ? ' *' : '')));
};
